// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
  KyberNetwork,
  Messages2,
  Calendar1,
  Kanban,
  Profile2User,
  Bill,
  UserSquare,
  ShoppingBag,
  People,
  LocationAdd,
  User,
  Paintbucket,
  Category2,
  Filter,
  MoneyAdd,
  // Coffee,
  Cake,
  ArrowDown,
  // Signpost,
  BackSquare,
  UserTick,
  Unlock,
  WatchStatus,
  TruckFast,
  Strongbox,
  ProfileTick,
  UserAdd,
  SmsNotification,
  MirroringScreen
} from 'iconsax-react';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  application: KyberNetwork,
  chat: Messages2,
  bees: People,
  staff: ProfileTick,
  notification: People,
  city: LocationAdd,
  vendor: User,
  user: UserAdd,
  role: UserAdd,
  screens: MirroringScreen,
  sub_screens: MirroringScreen,
  sponsors: UserTick,
  inventory: WatchStatus,
  flavor: Cake,
  banners: SmsNotification,
  purchase: ShoppingBag,
  grn: TruckFast,
  quality_check: Strongbox,
  update_purchase: Unlock,
  Products: Paintbucket,
  orders: MoneyAdd,
  return: BackSquare,
  category: Category2,
  promocode: ArrowDown,
  filter: Filter,
  calendar: Calendar1,
  kanban: Kanban,
  customer: Profile2User,
  invoice: Bill,
  profile: UserSquare,
  ecommerce: ShoppingBag
};

// ==============================|| MENU ITEMS - APPLICATIONS ||============================== //

const users: NavItemType = {
  id: 'group-purchase',
  title: <FormattedMessage id="users Management" />,
  icon: icons.purchase,
  menu_id: 1,
  type: 'group',
  children: [

    {
      id: 'user',
      title: <FormattedMessage id="User" />,
      type: 'collapse',
      icon: icons.user,
      children: [
        {
          id: 'user-list',
          title: <FormattedMessage id="User List" />,
          type: 'item',
          url: '/apps/user/user-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-user',
          title: <FormattedMessage id="Add User" />,
          type: 'item',
          url: '/apps/user/add-new-user'
        }
      ]
    },
    {
      id: 'role',
      title: <FormattedMessage id="Role" />,
      type: 'collapse',
      icon: icons.role,
      children: [
        {
          id: 'role-list',
          title: <FormattedMessage id="Role List" />,
          type: 'item',
          url: '/apps/role/role-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-role',
          title: <FormattedMessage id="Add New Role" />,
          type: 'item',
          url: '/apps/role/add-new-role'
        }
      ]
    },
    {
      id: 'screens',
      title: <FormattedMessage id="Screens" />,
      type: 'collapse',
      icon: icons.screens,
      children: [
        {
          id: 'screens-list',
          title: <FormattedMessage id="Screens List" />,
          type: 'item',
          url: '/apps/screen_page/screens-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-screen',
          title: <FormattedMessage id="Add Screen" />,
          type: 'item',
          url: '/apps/screen_page/add-new-screen'
        }
      ]
    },
    {
      id: 'sub_screens',
      title: <FormattedMessage id="Sub Screens" />,
      type: 'collapse',
      icon: icons.sub_screens,
      children: [
        {
          id: 'sub-screens-list',
          title: <FormattedMessage id="Sub Screens List" />,
          type: 'item',
          url: '/apps/sub_screen_page/sub-screens-list',
          breadcrumbs: false
        },
        {
          id: 'add-new-sub-screen',
          title: <FormattedMessage id="Add Sub Screen" />,
          type: 'item',
          url: '/apps/sub_screen_page/add-new-sub-screen'
        }
      ]
    },

  ]
};

export default users;
